// extracted by mini-css-extract-plugin
export default {"product-form__copy-paste-popup":"product-form__copy-paste-popup_c7X4_iIP"};